import { useAtomValue } from "jotai";
import { ClipLoader } from "react-spinners";

import { Line, toast } from "@sorcery/ui";

import { useAuth } from "~/providers/AuthProvider";
import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import { useUser } from "~/providers/UserProvider";
import { deckJotai } from "~/state/deckJotai";
import { api } from "~/utils/trpc";

export const PreconToolbar = () => {
  const { user } = useUser();
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const precon = useAtomValue(deckJotai)!;
  const { openModal } = useModal();
  const { login } = useAuth();
  const trpcUtils = api.useUtils();

  const { mutateAsync: addPrecon, isPending } = api.collection.addPrecon.useMutation({
    onSuccess: () => {
      toast("Precon deck added to collection");
      void trpcUtils.collection.getBySession.invalidate();
      void trpcUtils.collection.getCollectionlistBySession.invalidate();
      void trpcUtils.collection.search.invalidate();
    },
  });

  const addToCollection = () => {
    void addPrecon({ preconId: precon.id });
  };

  return (
    <>
      <Line className="my-1" />

      {user ? (
        <button
          type="button"
          disabled={isPending}
          className={"mr-4 inline-flex items-center text-sm sm:mr-6"}
          onClick={() => openModal(ModalTypeEnum.COPYDECK)}
        >
          <div className={"flex items-center italic transition-all hover:font-bold"}>
            <div>Copy to Deck</div>
          </div>
        </button>
      ) : (
        <button
          type="button"
          className={"mr-4 inline-flex items-center text-sm sm:mr-6"}
          onClick={() => {
            void login();
          }}
        >
          <span className={"italic transition-all hover:font-bold"}>
            <span>Want to copy this list to a deck? Login</span>
          </span>
        </button>
      )}

      {user ? (
        <button
          type="button"
          disabled={isPending}
          className={"mr-4 inline-flex items-center text-sm sm:mr-6"}
          onClick={addToCollection}
        >
          <div className={"flex items-center italic transition-all hover:font-bold"}>
            {isPending && (
              <div className="mt-0.5 pr-2 opacity-70 duration-1000 animate-in fade-in">
                <ClipLoader
                  className={"!border-l-white !border-r-white !border-t-white"}
                  size={12}
                />
              </div>
            )}
            <div>Add to Collection</div>
          </div>
        </button>
      ) : (
        <button
          type="button"
          className={"mr-4 inline-flex items-center text-sm sm:mr-6"}
          onClick={() => {
            void login();
          }}
        >
          <span className={"italic transition-all hover:font-bold"}>
            <span>Want to add this product directly to your Collection? Login</span>
          </span>
        </button>
      )}

      <Line className="mb-6 mt-1.5" />
    </>
  );
};
